import { AppConfig } from '../types'

type StageReturn = 'develop' | 'release' | 'master'

export const timeout = async (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms))

export const getStage = (appConfig: AppConfig): StageReturn => appConfig.stage as StageReturn
